<div [class.subform-open]="subform?.open">
    <mat-expansion-panel [expanded]="expanded">
        <mat-expansion-panel-header class="mat-expansion-panel-header">
            <mat-panel-title>
                <div class="header-wrapper">
                    <span class="title-wrapper">
                        <ng-content select="[mgdFormSectionIcon]"></ng-content>
                        <ng-content select="[mgdFormSectionHeader]"></ng-content>
                        <mgd-indicator variant="count" [count]="count"></mgd-indicator>
                    </span>
                    @if (headerDescription) {
                        <span class="description-wrapper">
                            <ng-content select="[mgdFormSectionHeaderDescription]"></ng-content>
                        </span>
                    }
                </div>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-content></ng-content>
    </mat-expansion-panel>
</div>
